/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import { type CouponApiProps, CouponApiPropsSchema } from '../shared/coupon'
import {
  LooseRichTextSchema,
  type LoosenRichTextFields,
} from '../types/loose-rich-text'
import type { Equal, ExpectTrue } from '../types/validation'

import { type CmsButtonApiProps, CmsButtonApiPropsSchema } from './cms-button'
import type { RichText } from './rich-text'
import {
  type SectionBannerBackgroundApiProps,
  SectionBannerBackgroundApiPropsSchema,
} from './section-banner'

/* TypeScript */
export type CountdownBannerApiProps = {
  technicalName?: Maybe<string>
  coupon?: Maybe<CouponApiProps>
  title: RichText
  subtitle?: Maybe<RichText>
  saleStartDate: string
  button?: Maybe<CmsButtonApiProps>
  mood?: Maybe<'main' | 'inverse'>
} & SectionBannerBackgroundApiProps

/* Schemas */
export const CountdownBannerApiPropsSchema = z.intersection(
  z.object({
    technicalName: z.nullish(z.string()),
    coupon: z.nullish(CouponApiPropsSchema),
    title: LooseRichTextSchema,
    subtitle: z.nullish(LooseRichTextSchema),
    saleStartDate: z.iso.datetime(),
    button: z.nullish(CmsButtonApiPropsSchema),
    mood: z.nullish(z.enum(['main', 'inverse'])),
  }),
  SectionBannerBackgroundApiPropsSchema,
)

/* Schemas validation */
type TestSectionBannerApiProps = ExpectTrue<
  Equal<
    LoosenRichTextFields<CountdownBannerApiProps>,
    z.infer<typeof CountdownBannerApiPropsSchema>
  >
>
